// extracted by mini-css-extract-plugin
export default {"container":"SavedSearches_container__NdoBb","cardsContainer":"SavedSearches_cardsContainer__ASOch","searchItem":"SavedSearches_searchItem__IMP3J"};